import React, { forwardRef, useImperativeHandle, useRef } from 'react'

import BaseTemplateInput, {
  type BaseTemplateInputHandle,
} from '~/components/dashboard/template-inputs/BaseTemplateInput/BaseTemplateInput'

interface LabNotesEditorProps {
  disabled?: boolean
  onChange: (value: string) => void
  value: string
}

export interface LabNotesEditorHandle {
  appendHtml: (html: string | string[]) => void
  getValue: () => string
}

const LabNotesEditor = forwardRef<LabNotesEditorHandle, LabNotesEditorProps>(
  function LabNotesEditor(
    { disabled, value, onChange }: LabNotesEditorProps,
    ref,
  ) {
    const editorRef = useRef<BaseTemplateInputHandle>(null)

    useImperativeHandle(ref, () => ({
      appendHtml: (html: string | string[]) => {
        const htmlStr = Array.isArray(html) ? html.join('\n') : html
        const current = editorRef.current?.getData() ?? value ?? ''
        const merged = current ? `${current}<br/><br/>${htmlStr}` : htmlStr
        editorRef.current?.setInitialValue(merged)
        onChange(merged)
      },
      getValue: () => editorRef.current?.getData() ?? value ?? '',
    }))

    return (
      <BaseTemplateInput
        hidePanel
        hidePlusButtonBlock
        isChirp
        disabled={disabled}
        filter={[]}
        label=""
        minEditorHeight={120}
        ref={editorRef}
        showAttachment={false}
        showDynamicText={false}
        singleLine={false}
        value={value}
        onChange={onChange}
      />
    )
  },
)

export default LabNotesEditor
